import React from 'react';
import { makeStyles } from "@material-ui/core";
import SuccessPaymentImg from "../../assets/images/successful_payment.svg";

const useStyles = makeStyles((theme) => ({
    paymentSuccessBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100vh - 160px)',
        '& img': {
            width: 300,
        },
        '& h4': {
            fontSize: 18,
            color: '#008C74',
            fontWeight: 'bold'
        }
    },
}));

const PaymentSuccessView = props => {
    const classes = useStyles();
    return (
        <div className={classes.paymentSuccessBlock}>
            <img src={SuccessPaymentImg} alt=""/>
            <h4>Payment Successfully done!</h4>
        </div>
    );
};

export default PaymentSuccessView;
